import Vue from "vue"

export default {
  namespaced: true,
  state: {
    event: null
  },
  getters: {
    event: state => state.event,
    slug: state => (_.has(state.event, "slug") ? state.event.slug : null),
    formattedEventPeriod: state => {
      const event = state.event
      const $moment = Vue.prototype.$moment
      const start = $moment(event.start_date)
      const end = $moment(event.end_date)
      return start.is_same_date
        ? `${start.format("LL")} ${$moment(event.open_at).format("LT")} ~ ${$moment(event.close_at).format("LT")}`
        : `${start.format("LL")} ~ ${end.format("LL")} 各日 ${$moment(event.open_at).format("LT")} ~ ${$moment(event.close_at).format("LT")}`
    }
  },
  mutations: {
    setEvent(state, event) {
      state.event = event
    }
  },
  actions: {
    /**
     * イベントの取得
     * @param {object} context
     * @param {string} slug
     * @returns {Promise<void>}
     */
    async getEvent(context, slug) {
      await this._vm.$axios
        .get(`events/${slug}`)
        .then(response => {
          context.commit("setEvent", response.data.event)
        })
        .catch(error => {
          console.error(error)
        })
    }
  }
}
